// components/Posts/StageFilter.tsx
import React from "react";
import {
  PostStage,
  STAGE_CONFIGS,
} from "@/domains/PostCreator/utils/stageConfig";
import { TabGroup, TabItem, TabGroupConfig } from "@/components/ui/TabGroup";

interface StageFilterProps {
  activeStage: PostStage | null;
  onStageChange: (stage: PostStage) => void;
  stageCounts?: { [key in PostStage]: number };
  isLoading?: boolean;
}

export const StageFilter: React.FC<StageFilterProps> = ({
  activeStage,
  onStageChange,
  stageCounts = {},
  isLoading = false,
}) => {
  const totalPosts = Object.values(stageCounts).reduce(
    (sum: number, count: any) => sum + count,
    0,
  ) as number;

  // Color mapping for stages - one per PostStatus
  const stageColorMap: Record<PostStage, string> = {
    ai_generated: "bg-violet-500",
    draft: "bg-slate-500",
    caption_generated: "bg-blue-500",
    approval_pending: "bg-amber-500",
    ready: "bg-teal-500",
    scheduled: "bg-purple-500",
    partially_published: "bg-orange-500",
    published: "bg-emerald-500",
    archived: "bg-gray-500",
    all: "",
  };

  // Create tab items - include all stage tabs
  const stageTabItems: TabItem<PostStage>[] = STAGE_CONFIGS.map((stage) => ({
    id: stage.id,
    label: stage.label,
    icon: stage.id !== "all" ? <div className={`w-2 h-2 rounded-full ${stageColorMap[stage.id]}`}></div> : undefined,
    badge: (stageCounts[stage.id] || 0) > 0 ? (stageCounts[stage.id] || 0) : undefined,
    badgeVariant: 'default' as const,
  }));

  const stageTabConfig: TabGroupConfig<PostStage> = {
    variant: 'navigation',
    size: 'sm',
    layout: 'horizontal',
    hasBackground: true,
  };

  const handleStageTabChange = (tabId: PostStage) => {
    onStageChange(tabId);
  };

  const currentActiveId = activeStage || "draft";

  return (
    <div className="inline-block">
      <TabGroup
        items={stageTabItems}
        activeId={currentActiveId}
        onTabChange={handleStageTabChange}
        config={stageTabConfig}
        isLoading={isLoading}
        loadingCount={6}
      />
    </div>
  );
};
